// components/providers.tsx
'use client'

import dynamic from 'next/dynamic'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'

// Dynamically import ReactQueryDevtools with ssr disabled
const ReactQueryDevtools = dynamic(
    () => import('@tanstack/react-query-devtools').then(mod => mod.ReactQueryDevtools),
    { ssr: false }
)

export function Providers({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        staleTime: 60 * 1000,
                    },
                },
            })
    )

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    )
}